import { get } from "lodash";
import { useEffect } from "react";

import { useGetTrustedPersonsLazyQuery } from "~/schemas/generated/graphql";

export const useTrustedPersons = () => {
  const [getTrustedPersons, getTrustedPersonsState] =
    useGetTrustedPersonsLazyQuery({
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    getTrustedPersons();
  }, []);

  const dataOptions = get(
    getTrustedPersonsState.data,
    "TrustedPersonGetter.getTrustedPersons",
    [],
  ).map((el) => {
    return { label: el.fio, value: el.id };
  });

  return { dataOptions, trustedPersonsState: getTrustedPersonsState };
};
